export default __webpack_public_path__ + "static/media/science.87bd64a4.svg";